<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("menu.comm_extra") }}
          </h6>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.comm_extra") }}</h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
                <el-table-column :label="$t('lmg.comm')">
                <template slot-scope="{ row }" class="d-flex">
                  {{ row.Name }}
                </template>
                </el-table-column>

                <el-table-column :label="$t('lmg.ttype')">
                <template slot-scope="{  row }" class="d-flex">
                  {{ row.TransactionTypeName }}
                </template>
                </el-table-column>

                <!-- <el-table-column :label="$t('lmg.insure')">
                <template slot-scope="{  row }" class="d-flex">
                  {{ row.InsuranceName }}
                </template>
                </el-table-column>

                <el-table-column :label="$t('lmg.comm')">
                <template slot-scope="{  row }" class="d-flex">
                  {{ row.Commission }}
                </template>
                </el-table-column> -->

             

                <!-- <el-table-column :label="$t('lmg.comm_limitCnt')">
                <template slot-scope="{ $index, row }" class="d-flex">
                  {{ row.LimitCnt }}
                </template>
                </el-table-column> -->


              <el-table-column
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <!-- <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                  </base-button> -->
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <h1>{{ $t('lmg.comm') }}</h1>

      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="new-event--form" @submit.prevent="handleSubmit(onUpdateComm)">
        <base-input :label="$t('name')" v-model="md.Name" :name="$t('name')" rules="required"> </base-input>

        <base-input :label="$t('lmg.ttype')"  :name="$t('lmg.ttype')" rules="required" v-if="md.ID == 0">
          <el-select v-model="md.TransactionTypeID" :placeholder="$t('lmg.ttype')">
            <el-option
              v-for="option in ttype"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input    :label="$t('lmg.insure_type')"  :name="$t('lmg.insure_type')" rules="required"  v-if="false">
          <el-select v-model="md.InsuranceID" :placeholder="$t('lmg.insure_type')">
            <el-option
              v-for="option in insure"
              :key="option.ID"
              :label="option.ShowName"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input  v-if="false" :label="$t('lmg.comm_amount') + ' (%)'" v-model="md.Commission"  :name="$t('lmg.comm_amount')" rules="required|numeric">
        </base-input>

        <!-- <base-input :label="$t('lmg.comm_incentive')" v-model="md.Incentive"  :name="$t('lmg.comm_incentive')" rules="required|numeric">
        </base-input> -->

        <base-input v-if="false" :label="$t('lmg.comm_limitCnt')" v-model="md.LimitCnt"  :name="$t('lmg.comm_limitCnt')" rules="required|numeric">
        </base-input>

      <div class="modal-footer">

        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </div>
      </form>
      </validation-observer>

    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Comm/getData",
      ttype: "Ttype/getData",
      insure: "Insure/getData"
    }),
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    }
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      commisionId : 0,
      md: {
        ID: 0,
        BranchName: "",
        Name: "",
        TransactionTypeID: "",
        TransactionTypeName: "",
        InsuranceID: "",
        InsuranceName: "",
        Commission: "",
        Incentive: 0,
        LimitCnt: "" 
      }
    };
  },
  async mounted() {
      this.commisionId  = this.$route.query.id
    // await this.listData();
    // await this.listTtypeData();
    // await this.listInsureData();
  },
  methods: {
    ...mapActions({
      createData: "Comm/createData",
      updateData: "Comm/updateData",
      deleteData: "Comm/deleteData",
      listData: "Comm/listData",
      listTtypeData: "Ttype/listData",
      listInsureData: "Insure/listData"
    }),
    handleCreate() {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.BranchName = "";
      this.md.Name = "";
      this.md.TransactionTypeID = "";
      this.md.TransactionTypeName = "";
      this.md.InsuranceID = "";
      this.md.InsuranceName = "";
      this.md.Commission = "";
      this.md.Incentive = 0;
      this.md.LimitCnt = ""; 
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.ID = row.ID;
      this.md.BranchName = row.BranchName;
      this.md.Name = row.Name;
      this.md.TransactionTypeID = row.TransactionTypeID;
      this.md.TransactionTypeName = row.TransactionTypeName;
      this.md.InsuranceID = row.InsuranceID;
      this.md.InsuranceName = row.InsuranceName;
      this.md.Commission = row.Commission;
      this.md.Incentive = row.Incentive;
      this.md.LimitCnt = row.LimitCnt;
    },
    onUpdateComm() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData({
          name: this.md.Name,
          transactionTypeID: this.md.TransactionTypeID,
          // insuranceID: this.md.InsuranceID,
          // commission: this.md.Commission,
          // incentive: this.md.Incentive,
          // limitCnt: this.md.LimitCnt
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        // update

        this.updateData({
          ID: this.md.ID,
          name: this.md.Name,
          commission: this.md.Commission,
          incentive: this.md.Incentive,
          limitCnt: this.md.LimitCnt
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              ID: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
